import React, { useEffect, useState,useMemo,useCallback } from 'react';
import { Container, Stepper, Step, StepLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FormProvider, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom'
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import styles from './View.Style';
import withStyles from '@material-ui/core/styles/withStyles';

import { ChallengeDetails } from './ChallengeDetails';
import { SelectIdeaTemplate } from './IdeaTemplateSelect';
import { EvaluationFlow } from './EvalutionFlow';
import { ChallengeOwner } from './ChallengeOwner';
import { ChallengePreview } from './ChallengePreview';
import CustomButton from 'components_newui/customButton/CustomButton';

const useStyles = makeStyles((theme) => ({
  root: { width: '100%' },
  title: {
    fontFamily: 'VodafoneRg-bold',
    fontSize: '2.125rem',
    margin: '1rem 0 2rem 0',
    textAlign: 'left',
    paddingTop: '1rem',
    color: '#333',
  },
  backButton: { marginRight: theme.spacing(1) },
  instructions: { marginTop: theme.spacing(1), marginBottom: theme.spacing(1) },
  instructions1: { marginTop: theme.spacing(1), marginBottom: theme.spacing(3) },
}));

const getDefaultValues = (draft, email) => ({
  id: draft?.id || '',
  title: '',
  summary: '',
  category: '',
  startingDate: null,
  closingDate: null,
  images:[],
  termsAndConditions: '',
  templateIdea: null,
  templateScorecard: null,
  communities: [],
  groupIds: 1,
  challengeOwner: '',
  isInnovate: true,
});


const today = new Date();
today.setHours(0, 0, 0, 0);
const tomorrow = new Date(today);

tomorrow.setDate(tomorrow.getDate() + 1);
// console.log("🚀 ~ tomorrow:", tomorrow)
const stepConfig = [
  {
    label: 'Challenge Details',
    component: ChallengeDetails,
    validationSchema: yup.object({
      isHackathonChallenge: yup.string().required('hackthon challenge field is required'),
      title: yup.string()
     
      .min(3,'Minimum 3 characters')
      .max(100, 'Maximum 100 characters')
      .required()
      .trim()
      .matches(
        /^[a-zA-Z0-9_ #!?|]*$/,
        'Only letters, numbers, spaces, underscore (_), hash (#), exclamation (!), question mark (?), and pipe (|) are allowed'
      ),
      summary: yup.string().required().trim(),
      category: yup.string().required(),
      startingDate: yup.date().nullable().required().min(today),

      closingDate: yup.date()
.required('Submission End Date is required')
.test(
  'is-after-start',
  'Submission End Date must be after Submission Start Date',
  function (endDate) {
    const { startingDate } = this.parent;
    return (
      startingDate &&
      endDate &&
      new Date(endDate) > new Date(startingDate)
    );
  }
),


//       closingDate: yup.date()
// .required('End date is required')
// .test(
//   'is-after-start',
//   'End date must be after start date',
//   function (endDate) {
//     const { startDate } = this.parent;
//     return startDate && endDate && new Date(endDate) > new Date(startDate);
//   }
// ),


      // closingDate: yup
      //   .date()
      //   .nullable()
      //   .transform((curr, orig) => {
      //     console.log('closingDate input:', orig);
      //     return orig === '' || Number.isNaN(new Date(orig).getTime()) ? null : new Date(orig);
      //   })
      //   .required('Closing date is required')
      //   .min(tomorrow, 'Closing date must be after today'),


        // .when('startingDate', (start, schema) =>
        //   start
        //     ? schema.min(
        //       new Date(new Date(start).getTime() + 86400000),
        //       'Closing date must be at least one day after the start date'
        //     )
        //     : schema
        // ),
      
      coverPhoto: yup.array()
        .of(
          yup
            .mixed()
            .test(
              'fileSize',
              'Image must be less than 10 MB',
              (value) => {
                const file = value?.file;
                if (!file || typeof file.size !== 'number') return false;
                return file.size / (1024 * 1024) <= 10;
              }
            )
        )
        .min(1, 'At least one image is required')
        .required('Cover photo is required'),
      termsAndConditions: yup.string().required().trim(),
    }),
  },
  {
    label: 'Idea Template Selection',
    component: SelectIdeaTemplate,
    validationSchema: yup.object({
      templateIdea: yup.object().required(),
    }),
  },
  {
    label: 'Evaluation Workflow',
    component: EvaluationFlow,
    validationSchema: yup.object({
      templateScorecard: yup.object().required(),
    }),
  },
  {
    label: 'Owner & Communities',
    component: ChallengeOwner,
    validationSchema: yup.object({
      communities: yup.array()
        .min(1, 'At least one community is required')
        .required('Community selection is required'),
    })
  },
  {
    label: 'Challenge Summary',
    component: ChallengePreview,
    validationSchema: yup.object(),
  },
];

const ChallengeFlow = (props) => {

  const {
    getInnovateChallengeDraftIdAddImage,
    draftGetInnovateChallenge,
    getChallengeIntoInnovateDraftFn,
    getCommunitesAsGroup,
    DraftInnovateChallenge,
    getIdeaTemplatelistFn,
    getScorecardTemplatelistFn,
    getInnovateChallengeActiveTypesFn,
    postInnovateChallengeCreateFn,
    saveDraftChallengeToBackend,createInnovateChallengeLoading,
    DraftInnovateChallengeLoading,
    isAdmin,
    isInnovator,
    userEmail,
  } = props || {};
  
  const classes = useStyles();
  const [selectedUsers, setSelectedUsers] = useState([])
  const [activeStep, setActiveStep] = useState(0);
  // const showEmail = isAdmin ? userEmail : 'N/A'
  const currentStep = stepConfig[activeStep];
 
  const defaultValues = useMemo(() => getDefaultValues(draftGetInnovateChallenge, userEmail), [draftGetInnovateChallenge, userEmail]);


  const methods = useForm({
    defaultValues,
    resolver: yupResolver(currentStep?.validationSchema),
    mode: 'onChange',
  });
  const { handleSubmit, trigger, getValues, reset } = methods;

  useEffect(() => {
    getChallengeIntoInnovateDraftFn?.();
    getIdeaTemplatelistFn?.();
    getScorecardTemplatelistFn?.();
    getInnovateChallengeActiveTypesFn?.();
    getCommunitesAsGroup?.();
  }, []);


  useEffect(() => {
    if (draftGetInnovateChallenge?.id) {
      reset((prev) => ({ ...prev, id: draftGetInnovateChallenge.id }));
    }
  }, [draftGetInnovateChallenge, reset]);
  

// console.log("selectedUsers!!!!!!===>",selectedUsers)


  const handleNext = useCallback(async () => {
    const isValid = await trigger();
    if (isValid) setActiveStep((prev) => prev + 1);
    window.scrollTo(0,0)
  }, [trigger]);

  const handleBack = useCallback(() => setActiveStep((prev) => prev - 1), []);
  

  const handleReset = () => {
    reset(defaultValues);
    setActiveStep(0);
  };

  // const updatedUsers = isInnovator && !isAdmin && userEmail
  // const updatedUsers = isInnovator || isAdmin || userEmail
  // ? [...selectedUsers, { value: userEmail }]
  // : selectedUsers;

  const updatedUsers =   [...selectedUsers, { value: userEmail }];

  const organizerEmails = [...new Set(updatedUsers.map(u => u.value))];


  const onSubmit = async (data) => {
    const allDataWithImg={
      ...data,
      images:getInnovateChallengeDraftIdAddImage?.image,
      challengeOwner:userEmail,
      organizerEmails
    }
    // console.log("submit- drftData-=0-0-0-0-0",data , allDataWithImg)
    // await saveDraftChallengeToBackend(data, showEmail);
    await postInnovateChallengeCreateFn(allDataWithImg, userEmail);
    reset(data); // Set submitted data as new default
  };
    

  const handleSaveDraft = async () => {
    const allData = getValues();
    const allDataWithImg={
      ...allData,
      images:getInnovateChallengeDraftIdAddImage?.image,
      challengeOwner:userEmail,
      organizerEmails
    }
    // console.log("prev- drftData-=0-0-0-0-0",allDataWithImg) 

    await saveDraftChallengeToBackend(allDataWithImg, userEmail);
  };
    

  const StepComponent = currentStep?.component;

  return (
    <Container>
      <h2 className={classes.title}> Create New Challenge </h2>
      <div className={classes.root}>

        <Stepper activeStep={activeStep} alternativeLabel>
          {stepConfig.map((step) => (
            <Step key={step.label}>
              <StepLabel>{step.label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        {activeStep === stepConfig.length ? (
          <div>
            <p className={classes.instructions}>All steps completed</p>
            <CustomButton type='button' onClick={handleReset}>Reset</CustomButton>
          </div>
        ) : (
          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className={classes.instructions}>
                <StepComponent {...props} formData={getValues()} mainImageValue={[]} selectedUsers={selectedUsers} onUserChange={setSelectedUsers} isAdmin={isAdmin} userEmail={userEmail} />
              </div>

              <div className={classes.instructions1}>
                <CustomButton
                  disabled={activeStep === 0}
                  onClick={handleBack}
                  className={classes.backButton}
                >
                  Back
                </CustomButton>
               

                {activeStep === stepConfig.length - 1 ? (
                  <>
                  <CustomButton
                    variant="contained" 
                    color="primary"
                    onClick={handleSaveDraft}
                    className={classes.backButton}
                    disabled={DraftInnovateChallengeLoading}
                  >
                    Draft
                  </CustomButton>
                  <CustomButton type="submit" disabled={createInnovateChallengeLoading} variant="contained" color="primary">
                    Submit Challenge
                  </CustomButton>
                  </>
                ) : (
                  <CustomButton type='button' onClick={handleNext} variant="contained" color="primary">
                    Next
                  </CustomButton>
                )}
              </div>
            </form>
          </FormProvider>
        )}
      </div>
    </Container>
  );
};

export default withStyles(styles)(ChallengeFlow);


// const renderStepper = () => (
//   <Stepper activeStep={activeStep} alternativeLabel>
//     {stepConfig.map((step) => (
//       <Step key={step.label}>
//         <StepLabel>{step.label}</StepLabel>
//       </Step>
//     ))}
//   </Stepper>
// );
